import { ReactNode } from 'react';

interface FormFieldProps {
  label: string;
  id?: string;
  required?: boolean;
  error?: string;
  helpText?: string;
  children: ReactNode;
}

export function FormField({ label, id, required, error, helpText, children }: FormFieldProps) {
  return (
    <div className="mb-6">
      <label htmlFor={id} className="label">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>

      {helpText && (
        <p className="text-sm text-gray-500 mt-1 mb-2">{helpText}</p>
      )}

      {children}

      {error && (
        <p className="mt-2 text-sm text-red-600" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
